import api from "../../../../lib/api";
import { IValueAddedServiceUpdatePayload } from "../../../../types/master/valueAddedServiceInterface";

export const getValueAddedServicesApi = async (search?: string) => {
  return await api.get("/value-added-services", { params: search ? { search } : undefined });
};

export const updateValueAddedServicesApi = async (payload: IValueAddedServiceUpdatePayload) => {
  return await api.put("/value-added-services", payload);
};
